import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    :root {\n        --reach-dialog: 1;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from 'styled-components'; // https://reach.tech/styling/

var ModalGlobalStyle = createGlobalStyle(_templateObject());
export default ModalGlobalStyle;